import { Form, InputNumber } from "antd";
import './index.less';
import { useTranslation } from "react-i18next";

function InputNumberAddon({ symbol, ...restProps }: any) {
  return (
    <div className="input-number-addon-box">
      <InputNumber className="mini-input-number" {...restProps} controls={false} />
      <div className="addon">
        {symbol}
      </div>
    </div>
  );
}

export default function RandomAmount({ form, symbol }: any) {
  const { t } = useTranslation()
  return (
    <div className="random-amount-box">
      <h3>{ t("manyToMany.sendAmountPerAddress") }</h3>

      <div className="form-items">
        <div className="col col-218">
          <Form.Item
            name="randomAmountStart"
            dependencies={['randomAmountEnd']}
            label={null}
            rules={[
              { required: true, message: t("manyToMany.startAmountIsRequired") },
              { type: 'number', min: 0.00001, message: t("manyToMany.valueMustBeGreaterThanZero") },
              {
                validator: (_: any, value: number) => {
                  const endValue = form.getFieldValue('randomAmountEnd');
                  if (value > 0 && (endValue === undefined || value < endValue)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(t("manyToMany.startValueMustBeGreaterThanZeroAndLessThanEndValue"));
                }
              }
            ]}
          >
            <InputNumberAddon symbol={symbol}/>
          </Form.Item>
        </div>
        <span className="span-12">~</span>
        <div className="col col-218">
          <Form.Item
            name="randomAmountEnd"
            dependencies={['randomAmountStart']}
            label={null}
            rules={[
              { required: true, message: t("manyToMany.endAmountIsRequired") },
              { type: 'number', min: 0.00002, message: t("manyToMany.valueMustBeGreaterThanZero") },
              {
                validator: (_: any, value: number) => {
                  const startValue = form.getFieldValue('randomAmountStart');
                  if (value > startValue) {
                    return Promise.resolve();
                  }
                  return Promise.reject(t("manyToMany.endValueMustBeGreaterThanStartValue"));
                }
              }
            ]}
          >
            <InputNumberAddon symbol={symbol}/>
          </Form.Item>
        </div>
      </div>
    </div>
  );
}
